module.exports = __webpack_public_path__ + "static/media/ico_close2.88aa4256.svg";